import React from 'react';
import './EndChatConfirmModal.css';

function EndChatConfirmModal({ onCancel, onConfirm, isJournalMode = false }) {
  return (
    <div className="modal-overlay">
      <div className="end-chat-modal">
        <div className="modal-header">
          <h2>{isJournalMode ? 'End Journaling?' : 'End Current Chat?'}</h2>
        </div>
        
        <div className="modal-body">
          <div className="warning-message">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" fill="#d97706"/>
            </svg>
            <p>
              If you end this {isJournalMode ? 'journal' : 'chat'}, you won't be able to continue it later. 
              Your conversation will be saved in your chat history.
            </p>
          </div>
        </div>
        
        <div className="modal-footer">
          <button className="modal-btn cancel-btn" onClick={onCancel}>
            Cancel
          </button>
          <button className="modal-btn confirm-btn" onClick={onConfirm}>
            {isJournalMode ? 'End Journaling' : 'End Chat'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EndChatConfirmModal;
